import React from 'react'

// Avoid jest/node build ESM fail: https://github.com/react-spring/react-spring/issues/494
import { Spring } from 'react-spring/renderprops.cjs'
const openStyleProps = {
  transform: 'translate3d(0,0,0)',
  boxShadow:
    '0px 2px 2px -1px rgba(0, 0, 0, 0.1), 0px 4px 7px 0px rgba(0, 0, 0, 0.04), 0px 1px 10px 0px rgba(0, 0, 0, 0.01)',
}

const closeStyleProps = {
  transform: 'translate3d(0,-64px,0)',
  boxShadow:
    '0px 2px 2px -1px rgba(0, 0, 0, 0.0), 0px 4px 7px 0px rgba(0, 0, 0, 0.0), 0px 1px 10px 0px rgba(0, 0, 0, 0.0)',
}

class SubBar extends React.PureComponent {
  render() {
    const { children } = this.props
    const { open } = this.props
    return (
      <Spring
        from={closeStyleProps}
        to={open ? openStyleProps : closeStyleProps}
        config={{
          tension: 200,
          friction: 16,
          mass: 0.5,
          clamp: true,
        }}
        // onRest={() => {
        //   this.setState({ showdow: this.props.open })
        // }}
      >
        {props => (
          <div
            style={{
              ...props,
              position: 'absolute',
              zIndex: 1500,
              width: '100%',
              height: '64px',
              // boxShadow: this.state.showdow ? boxShadowValue : 'none'
            }}
          >
            <div
              elevation={0}
              style={{
                width: '100%',
                height: '100%',
                backgroundColor: 'white',
              }}
            >
              <div style={{ paddingLeft: 12 }}>{children}</div>
            </div>
          </div>
        )}
      </Spring>
    )
  }
}

export default SubBar
